"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var HoverCard = __importStar(require("@radix-ui/react-hover-card"));
var stitches_config_1 = require("../stitches.config");
var Content = (0, stitches_config_1.styled)(HoverCard.Content, {
    width: "var(--radix-hover-card-trigger-width)",
});
function Popover(props) {
    var _a, _b;
    return ((0, jsx_runtime_1.jsxs)(HoverCard.Root, __assign({ open: props.open, onOpenChange: props.onOpenChange, openDelay: props.openDelay, closeDelay: props.closeDelay }, { children: [(0, jsx_runtime_1.jsx)(HoverCard.Trigger, __assign({ asChild: true }, { children: props.trigger })), props.portal ? ((0, jsx_runtime_1.jsx)(HoverCard.Portal, { children: (0, jsx_runtime_1.jsx)(Content, __assign({ side: (_a = props.side) !== null && _a !== void 0 ? _a : "top" }, { children: props.children })) })) : ((0, jsx_runtime_1.jsx)(Content, __assign({ side: (_b = props.side) !== null && _b !== void 0 ? _b : "top" }, { children: props.children })))] })));
}
exports.Popover = Popover;
//# sourceMappingURL=Popover.js.map